// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"e1abd495","120":"8797c6da","135":"c9fd51c2","355":"ce34774a","510":"df15ea76","544":"17ac7db8","546":"d100b04e","620":"4077f3e3","644":"83219bef","864":"5f46644e","881":"c22b1905","960":"b998b073","994":"b9107eaf"}[chunkId] + ".chunk.js";
};